module.exports = __webpack_public_path__ + "static/img/yy7.34fbd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy7.png
// module id = CBTU
// module chunks = 1